const footerLinks = [
  {
    title: '内容板块',
    links: [
      { label: '每日黑料', href: '#topics' },
      { label: '焦点专题', href: '#carousel' },
      { label: '图文资讯', href: '#cards' },
      { label: '精彩视频', href: '#media' },
      { label: '今日热榜', href: '#ranking' },
    ],
  },
  {
    title: '服务指南',
    links: [
      { label: 'App下载', href: '#app' },
      { label: '联系我们', href: '#contact' },
      { label: '常见问答', href: '#faq' },
      { label: '主题索引', href: '#index' },
      { label: '最新快讯', href: '#updates' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '读者热评', href: '#comments' },
      { label: '平台优势', href: '#features' },
    ],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="flex items-center gap-2 no-underline mb-4 cursor-pointer"
            >
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50 tracking-wide">
                今日看料
              </span>
            </a>
            <p className="text-foreground-300 text-sm leading-relaxed mt-3">
              美好生活从今日开始。每日精选热点资讯、独家爆料与深度话题，一站式信息消费平台。官网持续更新最新访问地址，App同步上线。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4 tracking-wide">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="mb-6">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-3 tracking-wide">
              合作伙伴
            </h4>
            <p className="text-foreground-500 text-xs">优质内容平台与媒体伙伴持续招募中</p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 今日看料. 本站内容仅供信息参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-foreground-500 text-xs">美好生活从今日开始</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}